<template>
	<div style="width:90%">

		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="通知标题:" class='tiny'>
						<el-input v-model="searchInfo.title" placeholder="请输入通知标题" />
					</el-form-item>
					<el-form-item label="商家名称:" class='tiny' cleartable v-if="storeId==0">
						<el-input v-model="searchInfo.storeName" placeholder="请输入商家名称" />
					</el-form-item>
					<el-form-item label="是否门店显示:" class='tiny' cleartable v-if="storeType==1&&storeId!=0">
						<el-select v-model="searchInfo.postionHomeStore" placeholder="请选择" style="width: 120px;">
					
							<el-option key="1" label="是" :value="true">是</el-option>
							<el-option key="0" label="否" :value="false">否</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否门店显示:" class='tiny' cleartable v-if="storeId==0" style="width: 120px;">
						<el-select v-model="searchInfo.postionHomeStore" placeholder="请选择">
					
							<el-option key="1" label="是" :value="true">是</el-option>
							<el-option key="0" label="否" :value="false">否</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="是否商城显示:" class='tiny' cleartable v-if="storeType==1&&storeId!=0" >
						<el-select v-model="searchInfo.postionHomeShop" placeholder="请选择" style="width: 120px;">
					
							<el-option key="1" label="是" :value="true">是</el-option>
							<el-option key="0" label="否" :value="false">否</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否商城显示:" class='tiny' cleartable v-if="storeId==0">
						<el-select v-model="searchInfo.postionHomeShop" placeholder="请选择" style="width: 120px;">
					
							<el-option key="1" label="是" :value="true">是</el-option>
							<el-option key="0" label="否" :value="false">否</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="状态:" class='tiny'>
						<el-select v-model="searchInfo.status"  style="width: 100px;">
							<el-option key="-1" label="全部" value="">全部</el-option>
							<el-option :value="true" label="启用">启用</el-option>
							<el-option :value="false" label="停用">停用</el-option>
						</el-select>
					</el-form-item>
					<el-form-item class='tiny'>
						<el-button type="primary" @click="search">搜索</el-button>
						<el-button @click="empty">清空</el-button>
					</el-form-item>
					<el-form-item class='tiny'>
						<el-button type="primary" @click="editialogVisible('')">新增
						</el-button>
					</el-form-item>
						

				</el-form>
			</header>
		</div>

		<el-table :data="messageList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="storeName" label="商家" align="center" width="150"  v-if="storeId==0">
			</el-table-column>
			<el-table-column prop="title" label="通知标题" align="center"  width="300">
			</el-table-column>
			<!-- 
			<el-table-column prop="titleEn" label="英文通知标题" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			
			<el-table-column prop="postionHomeShop" label="是否商城显示" align="center"  width="120" v-if="storeType==1">
				<template slot-scope="scope">
					<p>
						{{ scope.row.postionHomeShop?'是':'否' }}
					</p>
					
				</template>
			</el-table-column>
			<el-table-column prop="postionHomeShop" label="是否商城显示" align="center"  width="120" v-if="storeId==0">
				<template slot-scope="scope">
					<p>
						{{ scope.row.postionHomeShop?'是':'否' }}
					</p>
					
				</template>
			</el-table-column>
			<el-table-column prop="postionHomeStore" label="是否门店显示"   width="120" align="center" v-if="storeType==1">
				<template slot-scope="scope">
					<p>
						{{ scope.row.postionHomeStore?'是':'否' }}
					</p>
					
				</template>
			</el-table-column>
			<el-table-column prop="postionHomeStore" label="是否门店显示"  width="120"  align="center" v-if="storeId==0">
				<template slot-scope="scope">
					<p>
						{{ scope.row.postionHomeStore?'是':'否' }}
					</p>
					
				</template>
			</el-table-column>
			<el-table-column prop="status" label="状态" align="center" width="80"  >
				<template slot-scope="scope">
					<p>
						{{ scope.row.status?'启用':'停用' }}
					</p>
					
				</template>
			</el-table-column>
			<el-table-column prop="content" label="内容"  width="80"  align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button v-if="scope.row.action == 'richtext'" size="small" type="text"
						@click="showContent(scope.row.content)">查看</el-button>
					<a :href="scope.row.content" v-if="scope.row.action == 'url'">查看</a>
				</template>
			</el-table-column>

			<!-- <el-table-column prop="contentEn" label="英文内容" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button v-if="scope.row.action == 'richtext'" size="small" type="text"
						@click="showContent(scope.row.contentEn)">查看</el-button>
					<a :href="scope.row.contentEn" v-if="scope.row.action == 'url'">查看</a>
				</template>
			</el-table-column> -->
			<el-table-column prop="beginDate" width="100%" label="开始时间" align="center">
			</el-table-column>
		<el-table-column prop="endDate" width="100%" label="结束时间" align="center">
		</el-table-column>
		

			<el-table-column prop="createDate" width="200%" label="创建时间" align="center">
			</el-table-column>
			<!-- <el-table-column prop="status" label="状态" align="center">
				<template slot-scope="scope">
					<p v-if="!scope.row.status">系统通知</p>
					<p v-if="scope.row.status == 'unread'">未读</p>
					<p v-if="scope.row.status == 'read'">已读</p>
				</template>
			</el-table-column> -->
			<el-table-column  label="操作"  fixed="right" align="center"  >
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row)">编辑</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					<el-button  size="small" v-if="!scope.row.status" type="text" @click="glstatus(scope.row.id,1)">启用</el-button>
					<el-button style="color: red;" size="small" v-else type="text" @click="glstatus(scope.row.id,2)">停用</el-button>　　　
					<!--<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">拨币</el-button> -->
					<el-dropdown v-if="scope.row.userId == 0" trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="readingecordCli(scope.row.id)">阅读记录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>
			</el-table-column>

		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="messageList.pageNum" @current-change="pageChange"
			layout="total, sizes, prev, pager, next, jumper" :total="messageList.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 查看 -->
		<el-dialog title="提示" :visible.sync="showContentDialog" width="50%">
			<span v-html="contentValue"></span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 阅读记录 -->
		<el-dialog title="阅读记录" :visible.sync="readingecord" width="50%" :close-on-click-modal="false">
			<el-table :data="MessageReadingRecordList.list" stripe style="width: 100%;" :header-cell-style="headClass"
				v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
				<!-- <el-table-column prop="id" label="序号" sortable align="center">
			    </el-table-column> -->
				<el-table-column prop="userId" label="用户id" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="username" label="用户登录名" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="createDate" label="阅读时间" align="center" :show-overflow-tooltip="true">
				</el-table-column>
			</el-table>

			<el-pagination style="margin: 20px;" background :current-page="MessageReadingRecordList.pageNum"
				@current-change="pageChangeReadingRecord" layout="total, sizes, prev, pager, next, jumper"
				:total="MessageReadingRecordList.total" @size-change="handleSizeChangeReadingRecord">
			</el-pagination>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="readingecord = false">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 编辑 -->
		<el-dialog style="float:rigin" :title="popupTitle" :visible.sync="editDialogVisible" width="50%" :close-on-click-modal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">
					<el-form-item label="选择店铺:" v-if="storeId == 0" style="width:615px;">
						<el-select v-model="storeIds" filterable 
						:remote-method="remoteMethod"
						:disabled="popupTitle == '编辑'?true:false"
						:loading="storeLoading"
						remote
						reserve-keyword
						class="big" placeholder="请输入并选择店铺" style="width: 300px;"
							@change="getStoreName">
							<el-option v-for="item in storeList" :key="item.id" :value="item.id"
								:label="item.storeName">
							</el-option> 
						</el-select>
					</el-form-item> 
					<el-form-item :label-width="formLabelWidth" label="通知标题:">
						<el-col :span="24">
							<el-input v-model="form.title" placeholder="请输入通知标题" />
						</el-col>
					</el-form-item>
					<!-- <el-form-item :label-width="formLabelWidth" label="英文通知标题:">
						<el-col :span="8">
							<el-input v-model="form.titleEn" placeholder="请输入英文通知标题" />
						</el-col>
					</el-form-item> -->
					<el-form-item :label-width="formLabelWidth" label="显示位置:" v-if="storeType==1&&storeId!=0">
						<el-checkbox-group v-model="postionList" >
						   <el-checkbox label="postionHomeStore" >门店</el-checkbox>
						   <el-checkbox label="postionHomeShop">商城</el-checkbox>
						  
						 </el-checkbox-group>
					</el-form-item>
					<el-form-item :label-width="formLabelWidth" label="显示位置:" v-if="storeId==0">
						<el-checkbox-group v-model="postionList" >
						   <el-checkbox label="postionHomeStore" v-if="storeGoodsInfo.storeType==1">门店</el-checkbox>
						   <el-checkbox label="postionHomeShop">商城</el-checkbox>
						  
						 </el-checkbox-group>
					</el-form-item>
								<el-form-item label="有效期:"  style="">
									<el-date-picker v-model="beginDate"  style="width: 150px;"
										value-format="yyyy-MM-dd" type="date" placeholder="选择开始时间">
									</el-date-picker>
									<p style="padding: 0 10px;">-</p>
									<el-date-picker v-model="endDate" style="width: 150px;"
										value-format="yyyy-MM-dd" type="date" placeholder="选择结束时间">
									</el-date-picker>
								</el-form-item>
					
						
					<!-- <el-form-item :label-width="formLabelWidth" label="用户名:">
						<el-col :span="8">
							<el-input v-model="form.username" placeholder="请输入用户名" />
						</el-col>
						<div style="width: 50px;display: inline-block;"></div>
						<el-button type="primary" @click="searchUserName">搜索</el-button>
						<el-button type="primary" @click="emptyUserName">清空</el-button>
					</el-form-item> -->

					

					<!-- <el-form-item label="打开方式:">
						<el-radio-group v-model="form.action">
							<el-radio label="richtext">富文本</el-radio>
							<el-radio label="url">URL</el-radio>
						</el-radio-group>
					</el-form-item> -->

					<el-form-item  label="内容:" prop="words" style="">
						<div id="lpc-quill" class="quill" style="height: 400px;">
							<el-upload v-show="false" ref="upload" class="upload-demo" style="height: 500px;" :action="httpUrl" :before-upload="beforeUpload"
								:on-success="upScuccess" :on-error="uploadError" />
							<quill-editor v-model="form.content" ref="myQuillEditor"  style="height: 300px;" class="editer" :options="editorOption"
								@ready="onEditorReady($event)">
							</quill-editor>
						</div>
					</el-form-item>
					<!-- <el-form-item v-if="form.action == 'richtext'" label="英文内容" prop="words">
						<div id="lpc-quill-en" class="quill">
							<el-upload v-show="false" ref="uploaden" class="upload-demo" :action="httpUrl"
								:before-upload="beforeUploaden" :on-success="upScuccessen" :on-error="uploadErroren" />
							<quill-editor v-model="form.contentEn" ref="myQuillEditoren" class="editer" :options="editorOptionen"
								@ready="onEditorReadyen($event)">
							</quill-editor>
						</div>
					</el-form-item> -->
					
					<!-- <el-form-item v-show="form.action == 'url'" :label-width="formLabelWidth" label="英文内容:">
						<el-col :span="8">
							<el-input v-model="form.contentEn" placeholder="请输入内容URL" />
						</el-col>
					</el-form-item> -->

					<el-form-item>
						<el-button :loading="toEditLoading" type="primary" @click="toEdit()">提交</el-button>
						<el-button @click="editDialogVisible = false">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('system');
	import {
		quillEditor
	} from 'vue-quill-editor' //调用编辑器
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				businessHours:'',
				storeGoodsInfo:{},
				popupTitle:'新增',
				postionList:[],
				title: '',
				systemMessage: null,
				loading: false,
				messageList: [], //通知
				storeIds:'',
				messageTypeList: [],
				MessageReadingRecordList: [], //阅读记录
				dialogVisible: false,
				editDialogVisible: false,
				beginDate:'',
				endDate:'',
				storeList:[],
				readingecord: false,
				form: {
					id: 0,
					title: "",
					titleEn: "",
					userId: 0,
					username: '',
					typeId: 0,
					action: "",
					status: "",
					content: "",
					contentEn: ""
				},
				mainFormRules: {
					title: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
				},
				toEditLoading:false,
				storeType:0,
				storeId:0,
				integralList: [],
				integralId: "", //积分id
				appropriation: "",
				storeLoading: false,
				ids: '', //授权用户id
				userData: [{}], //用户角色列表
				userDataList: [], //用户角色列表选中的
				formLabelWidth: "100px",
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {},
				index: null,
				postionHomeShop:false,
				postionHomeStore:false,
				contentValue: "",
				showContentDialog: false,
				httpUrl: urls,
				editorOption: { // 富文本编辑器配置
					placeholder: '请输入内容',
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
								[{
									'header': 1
								}, {
									'header': 2
								}], // 标题，键值对的形式；1、2表示字体大小
								[{
									'list': 'ordered'
								}, {
									'list': 'bullet'
								}], // 列表
								[{
									'script': 'sub'
								}, {
									'script': 'super'
								}], // 上下标
								[{
									'indent': '-1'
								}, {
									'indent': '+1'
								}], // 缩进
								[{
									'direction': 'rtl'
								}], // 文本方向
								[{
									'size': ['small', false, 'large', 'huge']
								}], // 字体大小
								[{
									'color': []
								}, {
									'background': []
								}], // 字体颜色，字体背景颜色
								[{
									'align': []
								}], // 对齐方式
								['clean'], // 清除字体样式
								['image'] // 上传图片、上传视频
							],
							handlers: {
								'image': function (value) {
									if (value) {
										document.querySelector('#lpc-quill .upload-demo input').click()
									} else {
										this.quill.format('image', false)
									}
								}
							}
						}
					},
					theme: 'snow'
				},
				editorOptionen: { // 富文本编辑器配置
					placeholder: '请输入英文内容',
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
								[{
									'header': 1
								}, {
									'header': 2
								}], // 标题，键值对的形式；1、2表示字体大小
								[{
									'list': 'ordered'
								}, {
									'list': 'bullet'
								}], // 列表
								[{
									'script': 'sub'
								}, {
									'script': 'super'
								}], // 上下标
								[{
									'indent': '-1'
								}, {
									'indent': '+1'
								}], // 缩进
								[{
									'direction': 'rtl'
								}], // 文本方向
								[{
									'size': ['small', false, 'large', 'huge']
								}], // 字体大小
								[{
									'color': []
								}, {
									'background': []
								}], // 字体颜色，字体背景颜色
								[{
									'align': []
								}], // 对齐方式
								['clean'], // 清除字体样式
								['image'] // 上传图片、上传视频
							],
							handlers: {
								'image': function (value) {
									if (value) {
										document.querySelector('#lpc-quill-en .upload-demo input').click()
									} else {
										this.quill.format('image', false)
									}
								}
							}
						}
					},
					theme: 'snow'
				}

			};
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		methods: {
			remoteMethod(query) {
				if (query.length >= 2) {
					this.storeLoading = true;
					setTimeout(() => {
						let data = {
							storeName: query,
						}
						this.$api.getStoreNameList(data).then((res) => { //店铺管理
							if (res.state == 'success') {
								this.storeList = res.data;
							} else {
								this.$message.error(res.message);
							}
						})
						this.storeLoading = false;
					}, 200);
					} else {
						this.storeList = [];
					}
			},
			empty() {
				this.title = '';
				this.searchInfo={}
			},
			search() {
				this.loading = true;
				this.page.title = this.title ? this.title : null;
				let webData = {
					pageNum: 1,
					pageSize: this.page.pageSize,
					...this.searchInfo
				}
				this.$api.storeUserNotify(webData).then((res) => { //角色管理列表
					if (res.state == 'success') {
						this.messageList = res.data
					}
					this.loading = false
				})
			},
			emptyUserName() {
				this.form.username = '';
			},
			glstatus(e,type){
				if(type==2){
					var str = "此操作将停用该通知, 是否继续?"
				}else{
					var str = "此操作将启用该通知, 是否继续?"
				}
				
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(e)
					this.$api.updateStatusstoreUserNotify(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getMessageList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			showContent(content) {
				this.contentValue = content
				this.showContentDialog = true
			},
			//阅读记录弹框
			readingecordCli(msgid) {
				this.readingecord = true;
				this.getMessageReadingRecordList(msgid);
			},
			//编辑弹框
			editialogVisible(it) {
				this.form={}
				this.storeIds=''
				this.postionList=[]
				if (it.id) {
					//编辑查询
					this.popupTitle = '编辑'
					this.form=it
					this.storeIds=it.storeName
					this.beginDate=it.beginDate
					this.endDate=it.endDate
					
						this.postionHomeStore=this.form.postionHomeStore?true:false
						this.postionHomeShop=this.form.postionHomeShop?true:false
						if(this.postionHomeShop){
							this.postionList=this.postionList.concat('postionHomeShop')
							console.log(this.postionList);
						}
						if(this.postionHomeStore){
							this.postionList=this.postionList.concat('postionHomeStore')
							console.log(this.postionList);
						}
				} else {
					this.popupTitle = '新增'
					this.form = {}
				}
				this.editDialogVisible = true;
			},
			toEdit() {
				console.log(this.businessHours);
				this.toEditLoading = true;
				if (this.form.id) {
					//编辑
					
				if(this.postionList.find(item=>item=="postionHomeStore")!=undefined){
					this.postionHomeStore=true
				}else{
					this.postionHomeStore=false
				}
				if(this.postionList.find(item=>item=="postionHomeShop")!=undefined){
					this.postionHomeShop=true
				}else{
					this.postionHomeShop=false
				}
					this.form.endDate=this.endDate
					this.form.beginDate=this.beginDate
					let data = this.form;
					data.postionHomeShop=this.postionHomeShop
					data.postionHomeStore=this.postionHomeStore
					this.$api.upstoreUserNotify(data).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.getMessageList();
						} else {
							this.$message.error(res.message);
						}
						this.toEditLoading = false;
					})
				} else {
					if(this.postionList.find(item=>item=="postionHomeStore")!=undefined){
						this.postionHomeStore=1
					}else{
						this.postionHomeStore=0
					}
					if(this.postionList.find(item=>item=="postionHomeShop")!=undefined){
						this.postionHomeShop=1
					}else{
						this.postionHomeShop=0
					}
					//添加
					let data = {
						title: this.form.title,
						titleEn: this.form.titleEn,
						postionHomeShop:this.postionHomeShop,
						postionHomeStore:this.postionHomeStore,
						endDate:this.endDate,
						beginDate:this.beginDate,
						action: this.form.action,
						status: this.form.status,
						content: this.form.content,
						storeId: this.storeIds,
						// contentEn: this.form.contentEn
					}
					// console.log('传递参数--',data);
					this.$api.addstoreUserNotify(data).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.getMessageList();
						} else {
							this.$message.error(res.message);
						}
						this.toEditLoading = false;
					})
				}
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartStartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.startDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.endDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			//通知
			pageChange(data) {
				this.page.pageNum = data
				this.getMessageList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getMessageList()
			},
			getMessageList() {
				this.loading = true
				let data = this.page;
				this.$api.storeUserNotify(data).then((res) => { //通知
					console.log('表格数据--',res);
					if (res.state == 'success') {
						this.messageList = res.data
						this.loading = false
					}
				})
			},
			
			//阅读记录
			pageChangeReadingRecord(data) {
				this.page.pageNum = data
				this.getMessageReadingRecordList()
			},
			handleSizeChangeReadingRecord(val) {
				this.page.pageSize = val
				this.getMessageReadingRecordList()
			},
			getMessageReadingRecordList(msgId) {
				this.loading = true
				if (msgId) {
					this.page.msgId = msgId;
				}
				let data = this.page
				this.$api.queryMessageUserRead(data).then((res) => { //阅读记录
					console.log(res);
					if (res.state == 'success') {
						this.MessageReadingRecordList = res.data
						this.loading = false
					}
				})
			},
			//删除
			toDelete(id) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delstoreUserNotify(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getMessageList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			beforeUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			upScuccess(res, file) {
				console.log(res)
				const quill = this.$refs.myQuillEditor.quill
				if (res.state === 'success' && res.data !== null) {
					const length = quill.getSelection().index // 获取光标所在位置
					quill.insertEmbed(length, 'image', res.data) // 插入图片
					quill.setSelection(length + 1) // 调整光标位置到最后
				} else {
					this.$message.error('图片上传失败')
				}
				console.log(quill)
			},
			uploadError() {
				this.$message.error('图片上传失败')
			},
			onEditorReady(editor) { // 准备编辑器
				console.log(editor)
			},
			beforeUploaden(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			getStoreName(e) {
				// console.log(e);
				// this.supplierId = ''
				// this.storeNameId = e
				// console.log(this.selectStoreName);
				// console.log(e);
				let obj = {};
				obj = this.storeList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.storeType = obj.storeType;
				this.storeGoodsInfo.storeId = e;
				
			
			},
			upScuccessen(res, file) {
				const quill = this.$refs.myQuillEditoren.quill
				if (res.state === 'success' && res.data !== null) {
					const length = quill.getSelection().index // 获取光标所在位置
					quill.insertEmbed(length, 'image', res.data) // 插入图片
					quill.setSelection(length + 1) // 调整光标位置到最后
				} else {
					this.$message.error('图片上传失败')
				}
			},
			uploadErroren() {
				this.$message.error('图片上传失败')
			},
			onEditorReadyen(editor) { // 准备编辑器
				console.log(editor)
			},
		},
		created() {
			this.getMessageList();
			this.$api.findCurrentUserStore().then(res => {
				
				
				if (res.state == 'success') {
					console.log(res.data,0);
					this.storeType=res.data.storeType
					this.storeId=res.data.storeId
				}
			})
			// this.$api.getStoreNameList({}).then(res=>{
			// 	this.storeList=res.data
			// })
		},
		mounted: function () { },
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}
</style>